// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__242-N","bigColWidth":"Table_bigColWidth__3h9xk","biggerColWidth":"Table_biggerColWidth__2LbV8","row":"Table_row__9kgiO","col":"Table_col__1IuN3"};